// Outer coords for the entire map (used to subtract the IL coords from).
const outerCoords = (google) => [
    new google.maps.LatLng(-85.1054596961173, -180),
    new google.maps.LatLng(85.1054596961173, -180),
    new google.maps.LatLng(85.1054596961173, 180),
    new google.maps.LatLng(-85.1054596961173, 180),
    new google.maps.LatLng(-85.1054596961173, 0),
];

// Outline of Illinois.
const CoordinatesIL = [
    { lat: 42.5116, lng: -90.629 },
    { lat: 42.4924, lng: -87.0213 },
    { lat: 41.7641, lng: -87.2067 },
    { lat: 41.7611, lng: -87.5226 },
    { lat: 39.6417, lng: -87.5336 },
    { lat: 39.3566, lng: -87.5308 },
    { lat: 39.1386, lng: -87.6517 },
    { lat: 38.9445, lng: -87.5157 },
    { lat: 38.7294, lng: -87.5047 },
    { lat: 38.6115, lng: -87.6146 },
    { lat: 38.4944, lng: -87.6544 },
    { lat: 38.374, lng: -87.778 },
    { lat: 38.2856, lng: -87.8371 },
    { lat: 38.2414, lng: -87.9758 },
    { lat: 38.1454, lng: -87.9291 },
    { lat: 37.9788, lng: -88.0225 },
    { lat: 37.89, lng: -88.0458 },
    { lat: 37.7881, lng: -88.0321 },
    { lat: 37.6349, lng: -88.1529 },
    { lat: 37.5097, lng: -88.0609 },
    { lat: 37.4149, lng: -88.4152 },
    { lat: 37.2828, lng: -88.5086 },
    { lat: 37.1428, lng: -88.4221 },
    { lat: 37.0585, lng: -88.499 },
    { lat: 37.1428, lng: -88.7256 },
    { lat: 37.2128, lng: -88.9453 },
    { lat: 37.1559, lng: -89.0689 },
    { lat: 37.0376, lng: -89.165 },
    { lat: 36.9894, lng: -89.2873 },
    { lat: 37.1505, lng: -89.4356 },
    { lat: 37.2762, lng: -89.5345 },
    { lat: 37.3996, lng: -89.4315 },
    { lat: 37.6936, lng: -89.5358 },
    { lat: 37.9767, lng: -89.967 },
    { lat: 38.2587, lng: -90.379 },
    { lat: 38.6169, lng: -90.2376 },
    { lat: 38.7573, lng: -90.1744 },
    { lat: 38.8247, lng: -90.1167 },
    { lat: 38.8846, lng: -90.1799 },
    { lat: 38.968, lng: -90.4504 },
    { lat: 38.8654, lng: -90.5905 },
    { lat: 39.0405, lng: -90.7086 },
    { lat: 39.2301, lng: -90.7306 },
    { lat: 39.3173, lng: -90.835 },
    { lat: 39.3853, lng: -90.9338 },
    { lat: 39.5559, lng: -91.1398 },
    { lat: 39.7262, lng: -91.3554 },
    { lat: 39.857, lng: -91.4406 },
    { lat: 39.994, lng: -91.4941 },
    { lat: 40.1694, lng: -91.512 },
    { lat: 40.3497, lng: -91.4667 },
    { lat: 40.4166, lng: -91.3939 },
    { lat: 40.5566, lng: -91.4021 },
    { lat: 40.6265, lng: -91.2524 },
    { lat: 40.6963, lng: -91.1151 },
    { lat: 40.8232, lng: -91.089 },
    { lat: 40.9312, lng: -90.9792 },
    { lat: 41.1642, lng: -91.0162 },
    { lat: 41.2355, lng: -91.1055 },
    { lat: 41.417, lng: -91.0368 },
    { lat: 41.4458, lng: -90.8487 },
    { lat: 41.4417, lng: -90.7251 },
    { lat: 41.5816, lng: -90.3516 },
    { lat: 41.7713, lng: -90.2637 },
    { lat: 41.9023, lng: -90.1538 },
    { lat: 42.0819, lng: -90.1758 },
    { lat: 42.2021, lng: -90.3598 },
    { lat: 42.2936, lng: -90.4395 },
    { lat: 42.4032, lng: -90.5356 },
    { lat: 42.4843, lng: -90.6564 },
];

const parser = new DOMParser();

export const MapPinIcon = () =>
    parser.parseFromString(
        `<svg class="pin" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="9" cy="9" r="9" fill="var(--pin-color, currentColor)"/>
        </svg>`,
        'image/svg+xml'
    ).documentElement;

export const createIllinoisMap = async (google, element) => {
    const { Map } = await google.maps.importLibrary('maps');

    var map = new Map(element, {
        mapId: '825fb0a9baac8f7',
        center: { lat: 41.8864, lng: -87.6216 },
        zoom: 7,
        minZoom: 4,
        isFractionalZoomEnabled: true,
        disableDefaultUI: true,
    });

    // Paint the IL outline.
    map.data.add({
        geometry: new google.maps.Data.Polygon([
            outerCoords(google),
            CoordinatesIL,
        ]),
        properties: { fill: '#fff' },
    });
    map.data.add({
        geometry: new google.maps.Data.Polygon([CoordinatesIL]),
        properties: { stroke: '#226771' },
    });

    // Style the IL overlay.
    map.data.setStyle((feature) => {
        var fill = feature.getProperty('fill');
        var stroke = feature.getProperty('stroke');
        return /** @type {!google.maps.Data.StyleOptions} */ ({
            fillColor: fill || 'transparent',
            fillOpacity: 0.7,
            strokeColor: stroke,
            strokeWeight: stroke ? 2 : 0,
        });
    });

    // Re-centre the map on IL.
    const bounds = new google.maps.LatLngBounds();
    CoordinatesIL.forEach(({ lat, lng }) => {
        bounds.extend(new google.maps.LatLng(lat, lng));
    });
    // Prevent zoom controls overlapping the IL map outline on mobile.
    const mapPadding = window.matchMedia('(max-width: 1023px)').matches
        ? { top: 50, right: 20, bottom: 20, left: 20 }
        : 46;
    map.fitBounds(bounds, mapPadding);

    return map;
};
